<mat-sidenav-container class="sidenav-container">
  <mat-nav-list class="sidebar" [ngClass]="{'collapsed': sidebarService.collapsed, 'is-mobile': sidebarService.isMobile}">
    <span class="menu">
      <button *ngIf="!sidebarService.isMobile" mat-icon-button (click)="sidebarService.toggleSidebar()">
        <mat-icon class="default-color" matListIcon>menu</mat-icon>
      </button>
    </span>

    <ng-container *ngFor="let link of links; let i = index">
      <h3 matCardSubtitle class="menu-divider" *ngIf="isAuthorized(link.scope) && link.isSeparator">{{link.title}}</h3>
      <mat-list-item
        *ngIf="isAuthorized(link.scope) && !link.isSeparator && !link.isGrow"
        (click)="routeAction(link)"
        [routerLink]="link.url"
        routerLinkActive="active-link"
        matTooltipClass="sidebar-tooltip"
        [matTooltipDisabled]="!sidebarService.collapsed"
        [matTooltip]="link.title"
        matTooltipPosition="after"
        class="{{link.extraclass}}"
      >
        <!-- <mat-icon matListItemIcon class="material-icons-outlined default-color">{{link.icon}}</mat-icon> -->
        <div matListItemTitle *ngIf="!sidebarService.collapsed">{{ link.title }}</div>
      </mat-list-item>
      <div [ngClass]="{'grow-element': link.isGrow}"></div>
    </ng-container>
  </mat-nav-list>
</mat-sidenav-container>
